import Modal from 'components/Modal'
import CreditAllocationRefundTx from 'views/MemberProfile/ManualTx/CreditAllocationRefundTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalCreditAllocationRefundTxRefundTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <CreditAllocationRefundTx onClose={onClose} />
    </Modal>
  )
}

export default ModalCreditAllocationRefundTxRefundTx
